module.exports = __webpack_public_path__ + "images/external_images/img/753x470/img5.jpg";